export const VehicleType = {
  Consumer: 0,
  DealerInventory: 1,
  DealerInventoryManualEntry: 2,
}

export const VehicleTypes = [
  { label: 'Consumer', value: VehicleType.Consumer },
  { label: 'Dealer Inventory (Automated Entry)', value: VehicleType.DealerInventory },
  { label: 'Dealer Inventory (Manual Entry)', value: VehicleType.DealerInventoryManualEntry },
]

export const normalizedVehicleType = Object.assign(
  {},
  ...VehicleTypes.map((x) => ({ [x.value]: x.label })),
)
